import { render } from "./photoSelect.vue?vue&type=template&id=20fcf2d8&scoped=true"
import script from "./photoSelect.vue?vue&type=script&lang=js"
export * from "./photoSelect.vue?vue&type=script&lang=js"

import "./photoSelect.vue?vue&type=style&index=0&id=20fcf2d8&lang=less&scoped=scoped"

import exportComponent from "F:\\project\\zifeiluntang\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20fcf2d8"]])

export default __exports__